import React, { Component } from 'react';
import StartPage from './StartPage';

class HomePage extends Component {

    render() {

        return (
            <div>
                <StartPage handleClick={this.handleClick} handleChange={this.handleChange} />
            </div>
        );
    }


}


export default HomePage;


// WEBPACK FOOTER //
// ./src/Components/HomePage.jsx